/**
 * @class PriceData
 */
export default class PriceData {
    /**
     * @param {Number}  priceType
     * @param {String}  priceTypeName
     * @param {Number}  valueType
     * @param {Number}  defaultValue
     * @param {Number}  customValue
     * @param {Number}  value
     * @param {Number}  priceGroup
     * @param {Boolean} editable
     * @param {String} priceGroupName
     */
    constructor(
        priceType,
        priceTypeName,
        valueType,
        defaultValue,
        customValue,
        value,
        priceGroup,
        editable,
        priceGroupName = null
    ) {
        this._priceType = priceType;
        this._priceTypeName = priceTypeName;
        this._valueType = valueType;
        this._defaultValue = defaultValue;
        this._customValue = customValue;
        this._value = value;
        this._priceGroup = priceGroup;
        this._editable = editable;
        this._default = customValue === 0 && defaultValue === value;
        this._priceGroupName = priceGroupName;
    }

    /**
     * @return {Number}
     */
    get priceType() {
        return this._priceType;
    }

    /**
     * @param {Number} priceType
     */
    set priceType(priceType) {
        this._priceType = priceType;
    }

    /**
     * @return {String}
     */
    get priceTypeName() {
        return this._priceTypeName;
    }

    /**
     * @param {String} priceTypeName
     */
    set priceTypeName(priceTypeName) {
        this._priceTypeName = priceTypeName;
    }

    /**
     * @return {Number}
     */
    get valueType() {
        return this._valueType;
    }

    /**
     * @param {Number} valueType
     */
    set valueType(valueType) {
        this._valueType = valueType;
    }

    /**
     * @return {Number}
     */
    get defaultValue() {
        return this._defaultValue;
    }

    /**
     * @param {Number} defaultValue
     */
    set defaultValue(defaultValue) {
        this._defaultValue = defaultValue;
    }

    /**
     * @return {Number}
     */
    get customValue() {
        return this._customValue;
    }

    /**
     * @param {Number} customValue
     */
    set customValue(customValue) {
        this._customValue = customValue;
    }

    /**
     * @return {Number}
     */
    get value() {
        return this._value;
    }

    /**
     * @param {Number} value
     */
    set value(value) {
        this._value = value;
    }

    /**
     * @return {Number}
     */
    get priceGroup() {
        return this._priceGroup;
    }

    /**
     * @param {Number} priceGroup
     */
    set priceGroup(priceGroup) {
        this._priceGroup = priceGroup;
    }

    /**
     * @return {Boolean}
     */
    get editable() {
        return this._editable;
    }

    /**
     * @param {Boolean} editable
     */
    set editable(editable) {
        this._editable = editable;
    }

    /**
     * @return {Boolean}
     */
    isDefault = () => {
        return this._default;
    };

    /**
     * @return {String}
     */
    get priceGroupName() {
        return this._priceGroupName;
    }

    /**
     * @param {String} priceName
     */
    set priceGroupName(priceGroupName) {
        this._priceType = priceGroupName;
    }
}
